export default {
  1: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '0.5rem',
        left: '1.09rem',
      },
    },
  },
  2: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '0.5rem',
        left: '1.09rem',
      },
      1: {
        bottom: '0.5rem',
        left: '1.81rem',
      },
    },
  },
  3: {
    imgStyle: {
      width: '0.5rem',
      height: '0.5rem',
      border: 0,
    },
    children: {
      0: {
        bottom: '0.5rem',
        left: '1.09rem',
      },
      1: {
        bottom: '0.5rem',
        left: '1.81rem',
      },
      2: {
        bottom: '0.5rem',
        left: '2.53rem',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/circleStylesProvenBrochure.ts